var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',_vm._l((_vm.items),function(n,i){return _c('v-flex',{key:i,attrs:{"xs6":"","md2":""}},[_c('badge-button',{attrs:{"hint":i+1,"focus":_vm.focus,"value":n,"color":_vm.color},on:{"buttonclick":function($event){return _vm.$emit('buttonclick', n, i)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }